/* eslint-disable arrow-body-style */
/* eslint-disable no-await-in-loop */
/* eslint-disable radix */
/* eslint-disable semi */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */

import {
    getFriendsScores as GBC_getFriendsScores,
    syncFriendListByPlatformPlayerId as GBC_syncFriendListByPlatformPlayerId,
    postScore as GBC_postScore,
} from '@sgorg/game-backend-client';

import { OMT_Utils } from './utils/OMT_Utils';
import { OMT_DataCache } from './utils/OMT_DataCache';

/**
 *  class for handling data related to SoftGames leaderboards
 */
export class OMT_Leaderboards {
    /**
     * constructor
     * @param {number} dataExpiry expiry time in seconds
     * @param {Object} cache OMT_DataCache instance
     */
    constructor(dataExpiry, cache) {
        this._dataExpiry = dataExpiry;
        this._cache = cache;
        this._yourScoreData = { score: 0 };
        this._offlineScoresDataKey = 'offline-scores';
    }

    /**
     * get your total score. default/default leaderboard data must have been loaded first or this will be 0.
     * @returns {number}
     */
    getYourTotalScore() {
        return this._yourScoreData.score;
    }

    /**
     * get friends scores from the game-backend
     * @param {string} leaderboardName
     * @param {string} instanceId
     * @returns {Array}
     */
    async _getFriendsScores(leaderboardName, instanceId) {
        return new Promise((resolve, reject) => {
            GBC_getFriendsScores({ leaderboardName, instanceId }).then((friendsScores) => {
                resolve(friendsScores);
            }).catch((error) => {
                resolve([]);
            });
        });
    }

    /**
     * get leaderboard entry list
     * @param {string} leaderboardName
     * @param {string} instanceId
     * @param {boolean} useCache
     * @returns {Array}
     */
    async getLeaderBoardEntries(leaderboardName, instanceId, useCache = true) {
        const cacheKey = `leaderboard_${leaderboardName}_${instanceId}`;
        try { // attempt to get leaderboard data
            if (useCache && !this._cache.isDataExpired(cacheKey, this._dataExpiry)) return this._cache.getData(cacheKey);
            if (!OMT.connect.isConnected()) return this._getOfflineScores(cacheKey);

            const leaderboardList = [];
            let leaderBoardEntryData = {};
            console.log("leaderboard");
            const friendsList = await OMT.friends.getFriendsList();
            const friendsScores = await this._getFriendsScores(leaderboardName, instanceId);
            let friendData;

            friendsScores.forEach((entry) => {
                for (let i = 0; i < friendsList.length; i++) {
                    friendData = friendsList[i];
                    // add friends data to the list
                    if (friendData.id === entry.user.playerId) {
                        leaderBoardEntryData = {};
                        leaderBoardEntryData.id = friendData.id;
                        leaderBoardEntryData.name = friendData.name;
                        leaderBoardEntryData.image = friendData.image;
                        leaderBoardEntryData.rank = entry.rank;
                        leaderBoardEntryData.score = entry.score;
                        leaderBoardEntryData.isCurrentUser = false;
                        leaderboardList.push(leaderBoardEntryData);
                    }
                }
                // merge in YOUR data to the list
                if (entry.user.playerId === OMT.envData.settings.user.userId) {
                    leaderBoardEntryData = {};
                    leaderBoardEntryData.id = OMT.envData.settings.user.userId;
                    leaderBoardEntryData.name = OMT.envData.settings.user.name;
                    leaderBoardEntryData.rank = entry.rank;
                    leaderBoardEntryData.score = entry.score;
                    leaderBoardEntryData.image = OMT.envData.settings.user.avatar;
                    leaderBoardEntryData.isCurrentUser = true;
                    leaderboardList.push(leaderBoardEntryData);

                    // store YOUR total score data
                    if (leaderboardName === 'default' && instanceId === 'default') {
                        this._yourScoreData = leaderBoardEntryData;
                    }
                }
            });
            // set the cache data
            this._cache.setData(cacheKey, leaderboardList);
            OMT_Utils.stylizedLog(`OMT_Leaderboards: leaderboard (${leaderboardName},${instanceId}) updated`);
            return leaderboardList;
        } catch (error) { // could not get leaderboard data use offline data
            return this._getOfflineScores(cacheKey);
        }
    }

    /**
     * post a score to a leaderboard
     * @param {string} leaderboardName
     * @param {string} instanceId
     * @param {number} score
     */
    async postScoreToLeaderboard(leaderboardName, instanceId, score) {
        let cacheKey;
        const postObj = { leaderboardName, instanceId, score };

        // friends / map positions
        if (leaderboardName === G.OMTsettings.global.leaderboardName) {
            cacheKey = 'friendsList';
            // game-backend is not connected
            if (!OMT.connect.isConnected()) {
                this._updateOfflineScores(cacheKey, postObj);
                return;
            }
            try { // try to post the score to the game-backend
                await GBC_postScore(postObj);
            } catch (error) {
                this._updateOfflineScores(cacheKey, postObj);
            }
        } else { // high score leaderboards
            cacheKey = `leaderboard_${leaderboardName}_${instanceId}`;
            // game-backend is not connected
            if (!OMT.connect.isConnected()) {
                this._updateOfflineScores(cacheKey, postObj);
                return;
            }
            // get leaderboard data if not set
            if (this._cache.getData(cacheKey) == null) {
                await this.getLeaderBoardEntries(leaderboardName, instanceId, false);
            }

            // update the cached highscore leaderboard
            this._updateCachedLeaderboard(cacheKey, score);

            try { // try to post the score to the game-backend
                await GBC_postScore(postObj);
            } catch (error) {
                this._updateOfflineScores(cacheKey, postObj);
            }
        }
    }

    /**
     * update score in cached leaderboard data
     * @param {string} leaderboardName
     * @param {string} instanceId
     * @param {number} score
     */
    _updateCachedLeaderboard(cacheKey, score) {
        if (this._cache.hasKey(cacheKey)) { // update the score value in the cached data
            let leaderboardList = this._cache.getData(cacheKey);
            // eslint-disable-next-line arrow-body-style
            let yourData = leaderboardList.find((leaderboardData) => { return leaderboardData.isCurrentUser });
            if (yourData) { // update score
                yourData.score = parseInt(score);
            } else { // insert new data if you are not in this list
                yourData = {};
                yourData.id = OMT.envData.settings.user.userId;
                yourData.name = OMT.envData.settings.user.name;
                yourData.score = parseInt(score);
                yourData.image = OMT.envData.settings.user.avatar;
                yourData.isCurrentUser = true;
                leaderboardList.push(yourData);
            }
            leaderboardList = leaderboardList.sort((a, b) => { return b.score - a.score });
            for (let i = 0; i < leaderboardList.length; i++) leaderboardList[i].rank = i + 1;
            this._cache.setData(cacheKey, leaderboardList, false);
        }
    }

    /**
     * update offline score if we could not post to the leaderboard
     * @param {string} cacheKey
     * @param {Object} postObj score post object
     */
    _updateOfflineScores(cacheKey, postObj) {
        // add to global score if global leaderboard
        if (cacheKey === 'leaderboard_default_default') {
            this._yourScoreData.score = postObj.score;
        }

        let offlineScores = OMT.userData.getUserData(this._offlineScoresDataKey);
        if (!offlineScores) offlineScores = {};
        const prevPostObj = offlineScores[cacheKey];

        // dont store if previous score is higher
        if (prevPostObj && prevPostObj.score > postObj.score) {
            return;
        }

        offlineScores[cacheKey] = postObj;
        OMT.userData.writeUserData(this._offlineScoresDataKey, offlineScores);
    }

    /**
     * get a offline scores for when leaderboard data cannot be fetched
     * @param {string} cacheKey
     */
    _getOfflineScores(cacheKey) {
        const offlineScores = OMT.userData.getUserData(this._offlineScoresDataKey);
        const score = offlineScores && offlineScores[cacheKey] ? offlineScores[cacheKey].score : 0;
        if (score === 0) return [];

        const leaderBoardEntryData = {};
        leaderBoardEntryData.id = OMT.envData.settings.user.userId;
        leaderBoardEntryData.name = OMT.envData.settings.user.name;
        leaderBoardEntryData.rank = 1;
        leaderBoardEntryData.score = score;
        leaderBoardEntryData.image = OMT.envData.settings.user.avatar;
        leaderBoardEntryData.isCurrentUser = true;
        return [leaderBoardEntryData];
    }

    /**
     * post any offline scores that were recorded
     */
    async postOfflineScores() {
        const offlineScores = OMT.userData.getUserData(this._offlineScoresDataKey);
        if (!offlineScores) return;

        const keyList = Object.keys(offlineScores);
        for (let i = 0; i < keyList.length; i++) {
            try {
                await GBC_postScore(offlineScores[keyList[i]]);
                OMT_Utils.stylizedLog(`OMT_Leaderboards: offline score(${keyList[i]}) posted succesfully`);
                delete offlineScores[keyList[i]];
            } catch (error) {
                OMT_Utils.stylizedLog('OMT_Leaderboards: failed to post offline score to game-backend', '#FFFF00');
            }
        }
        OMT.userData.writeUserData(this._offlineScoresDataKey, offlineScores);
    }
}